import { render, staticRenderFns } from "./LsvaMenu.vue?vue&type=template&id=1a0f0add&scoped=true&"
import script from "./LsvaMenu.vue?vue&type=script&lang=js&"
export * from "./LsvaMenu.vue?vue&type=script&lang=js&"
import style0 from "./LsvaMenu.vue?vue&type=style&index=0&id=1a0f0add&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0f0add",
  null
  
)

/* custom blocks */
import block0 from "./LsvaMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports